(() => {
  const ROOT_CLASS = 'hds-motion-ready';
  const REDUCE_QUERY = '(prefers-reduced-motion: reduce)';
  const motionMedia = window.matchMedia(REDUCE_QUERY);

  const revealSelectors = [
    '.hds-trust__item',
    '.hds-home-editorial__heading',
    '.hds-home-editorial__body',
    '.hds-home-editorial__media',
    '.hds-home-journeys__head > *',
    '.hds-home-journey',
    '.hds-process__head > *',
    '.hds-process__step',
    '.hds-health__media',
    '.hds-health__content',
    '.hds-founders__content',
    '.hds-founder-card',
    '.hds-service-pathways__head > *',
    '.hds-service-card',
    '.hds-faq__head > *',
    '.hds-faq details',
    '.hds-visit__grid > *'
  ];

  let observer;

  const setAppointmentDateMinimums = (scope = document) => {
    const now = new Date();
    const localToday = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    ['HdsAppointmentDate', 'HdsAppointmentAlternateDate'].forEach((id) => {
      const input = scope.querySelector?.(`#${id}`) || document.getElementById(id);
      if (!input) return;
      input.min = localToday;
      if (input.value && input.value < localToday) input.value = '';
    });
  };

  const showEverything = () => {
    document.querySelectorAll('.hds-motion-reveal').forEach((item) => {
      item.classList.add('is-visible');
      item.style.removeProperty('--hds-motion-delay');
    });
    document.querySelectorAll('.hds-home-hero').forEach((hero) => {
      hero.classList.add('is-motion-active');
    });
  };

  const markStaggered = (items) => {
    items.forEach((item, index) => {
      if (item.classList.contains('hds-motion-reveal')) return;
      item.classList.add('hds-motion-reveal');
      item.style.setProperty('--hds-motion-delay', `${Math.min(index % 4, 3) * 90}ms`);
    });
  };

  const initialiseMotion = (scope = document) => {
    document.documentElement.classList.add(ROOT_CLASS);
    setAppointmentDateMinimums(scope);

    const hero = scope.querySelector?.('.hds-home-hero');
    if (hero) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        hero.classList.add('is-motion-active');
      }));
    }

    revealSelectors.forEach((selector) => {
      markStaggered(Array.from(scope.querySelectorAll?.(selector) || []));
    });

    if (motionMedia.matches || !('IntersectionObserver' in window)) {
      showEverything();
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -9% 0px',
        threshold: 0.08
      });
    }

    scope.querySelectorAll?.('.hds-motion-reveal:not(.is-visible)').forEach((item) => {
      observer.observe(item);
    });
  };

  const respondToPreference = () => {
    if (motionMedia.matches) {
      observer?.disconnect();
      observer = undefined;
      showEverything();
    } else {
      initialiseMotion();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseMotion(), { once: true });
  } else {
    initialiseMotion();
  }

  motionMedia.addEventListener?.('change', respondToPreference);
  document.addEventListener('shopify:section:load', (event) => initialiseMotion(event.target));
})();
